import {
    apiCallFailed, importedPredefinedTexts, privateCoreLoggedIn, retrievedPredefinedTexts,
    retrievedPropertyDefinitions, savedPredefinedText, transactionImported
} from "../redux/actions";

// TODO: DRY
class PrivateCoreService {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    coreBaseUrl(customer) {
        let coreConfig = customer.configuration.privateCore;
        return (coreConfig.httpsEnabled ? "https://" : "http://") + coreConfig.dns + ":" + coreConfig.httpPort;
    }

    queryParams(params) {
        return Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
    }

    callService(customer, method, resource, expectedReturnCode, callback, body, jwt) {
        if(method !== "POST" && method !== "GET" && method !== "PUT" && method !== "DELETE") {
            throw new Error("The method should be POST, GET, PUT or DELETE.")
        }

        let returnCode = parseInt(expectedReturnCode, 10);
        if(isNaN(returnCode)) {
            throw new Error("The return code '"+expectedReturnCode+"' should be an integer.")
        }

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if(jwt) headers['Authorization'] = jwt;

        const dispatchError = (message) => {
            this.dispatch(apiCallFailed({ message }))
        }
        
        let core = this.coreBaseUrl(customer);

        let defaultError = "API call on " + core + " failed. ";

        function extractError(text) {
            let dom = new DOMParser().parseFromString(text, "application/xml");
            let found = dom.querySelector(".text-exception").getElementsByTagName("h1");
            if(found.length > 0) {
                return found[0].innerHTML
            }
            else {
                return defaultError
            }
        }

        return fetch(core + resource, {
            headers: headers,
            method: method,
            body: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : null,
        }).then(response => {
            switch(response.status) {
                case returnCode:
                    response.json()
                        .then(data => callback(data))
                        .catch();
                    break;
                default:
                    response.text()
                        .then(text => {
                            try {
                                let json = JSON.parse(text);
                                dispatchError(json.error)
                            }
                            catch(ex) {
                                console.warn("Could not parse json.");
                                console.warn(ex);
                                dispatchError(extractError(text));
                            }
                        })
                        .catch(reason => {
                            console.error(reason);
                            dispatchError(defaultError)
                        });

            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    login(customer, user, pass) {
        let callback = data => this.dispatch(privateCoreLoggedIn({...data, customer}));
        this.callService(customer, "POST", "/api/login", 200, callback, {username: user, password: pass});
    }

    getAllPredefinedTexts(customer, jwt, callback) {
        let resource = "/api/v1/predefined-texts/?all";
        this.callService(customer, "GET", resource, 200, callback, {}, jwt);
    }

    getPredefinedTexts(customer, jwt, limit, page) {
        let resource = "/api/v1/predefined-texts/?"+this.queryParams({page: page, limit: limit});
        let callback = data => this.dispatch(retrievedPredefinedTexts({predefinedTexts: data, customer}));
        this.callService(customer, "GET", resource, 200, callback, {}, jwt);
    }

    importPredefinedTexts(customer, jwt, predefinedTexts, clean) {
        let resource = "/api/v1/predefined-texts/import?"+this.queryParams({cleanImport: clean});
        let callback = data => this.dispatch(importedPredefinedTexts({predefinedTexts, customer}));
        this.callService(customer, "POST", resource, 200, callback, predefinedTexts, jwt);
    }

    postTransaction(customer, jwt, transaction, query, optionalCallback) {
        let resource = `/api/v1/transactions${query}`;
        let dispatchCallback = data => this.dispatch(transactionImported({transaction: data, customer}));

        this.callService(customer, "POST", resource, 200, (d) => {
            dispatchCallback(d);
            if(optionalCallback) {
                optionalCallback(d);
            }
        }, transaction, jwt);
    }

    postValuation(customer, jwt, valuation, query, optionalCallback) {
        let resource = `/api/v1/valuations${query}`;
        let dispatchCallback = data => this.dispatch(transactionImported({transaction: data, customer}));

        this.callService(customer, "POST", resource, 200, (d) => {
            dispatchCallback(d);
            if(optionalCallback) {
                optionalCallback(d);
            }
        }, valuation, jwt);
    }

    createPredefinedText(customer, jwt, predefinedText) {
        let resource = "/api/v1/predefined-texts/";
        let callback = data => this.dispatch(savedPredefinedText({predefinedText: data, customer}));
        this.callService(customer, "POST", resource, 200, callback, predefinedText, jwt);
    }

    editPredefinedText(customer, jwt, predefinedText) {
        if(!predefinedText.id) {
            throw new Error("Expected the 'id' attribute to be present in the predefined text.")
        }

        console.log(predefinedText);
        let resource = "/api/v1/predefined-texts/"+predefinedText.id;
        let callback = data => this.dispatch(savedPredefinedText({predefinedText: data, customer}));
        this.callService(customer, "PUT", resource, 200, callback, predefinedText, jwt);
    }

    deletePredefinedText(customer, jwt, predefinedText) {
        if(!predefinedText.id) {
            throw new Error("Expected the 'id' attribute to be present in the predefined text.")
        }

        let resource = "/api/v1/predefined-texts/"+predefinedText.id;
        let callback = data => this.dispatch(savedPredefinedText({predefinedText: data, customer}));
        this.callService(customer, "DELETE", resource, 200, callback, {}, jwt);
    }

    getPropertyDefinitions(customer, jwt) {
        let resource = "/api/v1/property-definitions/";
        let callback = data => this.dispatch(retrievedPropertyDefinitions({propertyDefinitions: data, customer}));
        this.callService(customer, "GET", resource, 200, callback, {}, jwt);
    }

}

export default PrivateCoreService



// WEBPACK FOOTER //
// ./src/services/PrivateCoreService.js